/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  //住所登録フォームの国項目非表示 (main-customers-addresses.liquid)
  HTMLElement.prototype.trigger = function(eStr) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent(eStr, true, true );
    this.dispatchEvent(e);
  }

  const specifyJapan = (domElement) => {
    selector_options = domElement.options;
    for(let i = 0; i < selector_options.length; i++ ){
      if(selector_options[i].value === 'Japan'){
        selector_options[i].selected = true;
        break;
      }
    }
    domElement.trigger("change");
  }

  //新規登録
  const new_address_country = document.getElementById('custom--address-new-country');
  if(new_address_country){specifyJapan(new_address_country);}
  //更新
  const edit_address_country = document.querySelectorAll('.custom--address-edit-country');
  if(edit_address_country){
    edit_address_country.forEach(element => specifyJapan(element));
    //初期値処理
    const edit_address_province = document.querySelectorAll('select[name="address[province]"]');
    edit_address_province.forEach(element => {
      if(element.dataset.default){
        selector_options = element.options;
        for(let i = 0; i < selector_options.length; i++ ){
          if(selector_options[i].innerText === element.dataset.default){
            selector_options[i].selected = true;
            break;
          }
        }
        element.trigger("change");
      }
    });
  }
  removeAdditionalFeeItem();
});

const createOptions = (_elem)=>{
  const elem_options_length = _elem.querySelectorAll("option").length;
  const list_brands = JSON.parse(window.localStorage.getItem('current_list_brands'));

  if(elem_options_length <= 1 && list_brands.length > 0){

    list_brands.forEach((brand)=>{
      let option = document.createElement('option');
      option.setAttribute("value", brand.brand_code);
      option.innerHTML = brand.brand_name;
      _elem.appendChild(option);
    })
  }
}

function convertClothCanBuy(clothNumber) {
  if (!clothNumber || isNaN(clothNumber)) return 0;

  if (clothNumber < 30 && clothNumber > 0) {
    return Number(clothNumber);
  }

  return 30;
}

async function handleValidateProvince(zipCode, userProvinceCode) {
  const numericZipCode = zipCode.replace(/\D/g, '');
  const numericProvince = userProvinceCode.replace(/\D/g, '');
  const zipCodePrefix = numericZipCode.substring(0, 3);
  try {
    const response = await fetch(
      `https://yubinbango.github.io/yubinbango-data/data/${zipCodePrefix}.js`
    );
    const responseText = await response.text();

    const jsonDataString = responseText.match(/\{.*\}/s)[0];
    const jsonData = JSON.parse(jsonDataString);

    const addressData = jsonData[numericZipCode];
    if (!addressData) {
      return false;
    }

    const zipCodeData = addressData[0];

    if (zipCodeData != numericProvince) {
      return false;
    }

    return true;
  } catch (error) {
    console.error('Lỗi khi gọi API YubinBango:', error);
    return true;
  }
}

async function handleValidateProvinceShipping(zipCode, userProvinceCode) {
  const numericZipCode = zipCode.replace(/\D/g, '');
  const numericProvince = userProvinceCode.replace(/\D/g, '');
  const zipCodePrefix = numericZipCode.substring(0, 3);

  try {
    const response = await fetch(
      `https://yubinbango.github.io/yubinbango-data/data/${zipCodePrefix}.js`
    );
    const responseText = await response.text();

    const jsonDataString = responseText.match(/\{.*\}/s)[0];
    const jsonData = JSON.parse(jsonDataString);
    const addressData = jsonData[numericZipCode];
    if (!addressData) {
      return false;
    }

    const zipCodeData = addressData[0];

    if (zipCodeData && zipCodeData == numericProvince) {
      return true;
    }

    return false;
  } catch (error) {
    return true;
  }
}

//2022.7.23 Add Start Function:Validation formdata
const validateData = async (_form_data,_order_type,_bulk_order_flg_for_booking,_receipt_items)=>{
  //error_flg：エラーがある場合true
  //error_msg:エラーメッセージを格納
  let error_flg = false,
      error_msg_list = [];
  document.querySelectorAll('.error-message').forEach(el => el.innerHTML = '');

  const error_msg_blank = "は、必ず指定してください。",
      error_msg_length10 = "は、10文字以下にしてください。",
      error_msg_length30 = "は、30文字以下にしてください。",
      error_msg_length35 = "は、35文字以下にしてください。",
      error_msg_length40 = "は、40文字以下にしてください。",
      error_msg_length60 = "は、60文字以下にしてください。",
      error_msg_length125 = "は、125文字以下にしてください。",
      error_msg_type_Num = "は、半角数字でご入力ください。",
      error_msg_type_NumAZ = "は、半角英数字でご入力ください。",
      error_msg_format_YYYY_MM_DD = "は、YYYY/MM/DD形式でご入力ください。",
      error_msg_past_day = "は翌日以降を設定してください。",
      r0t9 = /^[0-9]+$/,
      r0tZ = /^[0-9a-zA-Z-]*$/,
      rYYYY_MM_DD = /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/;

  const validateBlankReceptData = (_receipt_items, _column, _column_data, targetId) => {
    if(_receipt_items.find((item) => item.text === _column)?.status && _column_data.trim().length === 0){
      if(_column === "顧客注文No") {
        error_msg_list.push({ message: "貴社発注Noが未入力です", target: targetId });
      } else {
        error_msg_list.push({ message: _column + "が未入力です", target: targetId });
      }
      error_flg = true;
    }
  }

  if (_form_data.line_items[0].type === "CATALOG") {
    const {request_time, use_purpose, offer_company, planning_season, planning_season_note} = _form_data.sample_book_note;
    if (use_purpose.length == 0) {
      error_flg = true;
      error_msg_list.push({ message: "用途が未入力です", target: 'attributes[用途]' });
    }

    if (planning_season.length == 0) {
      error_flg = true;
      error_msg_list.push({message: "生産時期が未入力です", target: 'attributes[生産時期]'})
    }

    if (request_time.length == 0) {
      error_flg = true;
      error_msg_list.push({message: "現物必要時期が未入力です", target: 'attributes[現物必要時期]'})
    }

    if (use_purpose == "2" && (offer_company.length == 0 || offer_company.trim() === "")) {
      error_flg = true;
      error_msg_list.push({ message: "他社提案用の内容が未入力です", target: 'attributes[用途]' });
    }

    if (planning_season == "4" && (planning_season_note.length == 0 || planning_season_note.trim() === "")) {
      error_flg = true;
      error_msg_list.push({ message: "その他の内容が未入力です", target: 'attributes[生産時期]' });
    }
  }

  if (_form_data.line_items[0].type === "CUT" || _form_data.line_items[0].type === "PRINT") {
    let baseUnitErrorProductIds = [];
    $.each(_form_data.line_items, function(index, item) {
      if (item.handle != "balance") {
        if (_form_data.line_items[0].type === "CUT" && !item.sku.startsWith('cutfee')) {
          let quantityItem = $(`#CartItem--${item.variant_id} .QuantitySelector input.Only_display_QuantitySelector__TypeCut`)[0];
          let cloth = quantityItem.getAttribute("data-cloth");
          let color_name = quantityItem.getAttribute("data-color_name");
          let color_code = quantityItem.getAttribute("data-color_code");
          const formatMetaCloth = (parseInt(cloth * 10) / 10 || 0).toFixed(1);
          if(cloth * 10 < item.quantity) {
            error_flg = true;
            const targetId = `error_${item.variant_id}`;
            error_msg_list.push({
              message: `${item.parent_product_id} ${item.title} #${color_code} ${color_name} の在庫が不足しています。(在庫数：${formatMetaCloth}M)`,
              target: targetId
            });
          }
        } else if (_form_data.line_items[0].type === "PRINT" && !item.sku.startsWith('cutfee') && !item.sku.startsWith('printfee') && !item.sku.includes('_zuan_')) {
          let quantityItem = $(`#CartItem--${item.variant_id} .QuantitySelector input.Only_display_QuantitySelector__TypeCut`)[0];
          let cloth = convertClothCanBuy(quantityItem.getAttribute("data-cloth"));
          let color_name = quantityItem.getAttribute("data-color_name");
          let color_code = quantityItem.getAttribute("data-color_code");
          const formatMetaCloth = (parseInt(cloth * 10) / 10 || 0).toFixed(1);
          if(cloth < 10 || cloth * 10 < item.quantity) {
            error_flg = true;
            const targetId = `error_${item.variant_id}`; // Example target ID, adjust as needed
            error_msg_list.push({
              message: `${item.parent_product_id} ${item.title} #${color_code} ${color_name} の在庫が不足しています。(在庫数：${formatMetaCloth}M)`,
              target: targetId
            });
          }
        }
        if (!baseUnitErrorProductIds.includes(item.product_id) && !item.sku.startsWith('cutfee') && !item.sku.startsWith('printfee') && !item.sku.includes('zuan')) {
          let variantItem = $(`#CartItem--${item.variant_id}`)[0];
          let productBaseUnit = parseFloat(variantItem.getAttribute('data-base_unit'));
          if (productBaseUnit > 30) {
            productBaseUnit = 30;
          }
          if (productBaseUnit * 10 < item.quantity) {
            error_flg = true;
            baseUnitErrorProductIds.push(item.product_id);
            const targetId = `error_${item.product_id}`;

            error_msg_list.push({
              message: `${item.title}の数量がオーダー上限を超えています`,
              target: targetId
            });
          }
        }
      }
    });
  }
  if (_form_data.line_items[0].type === "PRINT") {
    let isErrorMinQuantity = false;
    $.each(_form_data.line_items, function(_, item) {
      if (!isErrorMinQuantity) {
        if (!item.sku.startsWith('cutfee')
          && !item.sku.startsWith('printfee')
          && !item.sku.includes('zuan')
          && item.quantity < 100
          && item.handle !== 'balance'
        ) {
          isErrorMinQuantity = true;
          error_flg = true;
          const targetId = `error_${item.variant_id}`;

          error_msg_list.push({
            message: `最低10m以上のご注文からお受けできます`,
            target: targetId
          });
        }
      }
    });
  }

  if (_form_data.line_items[0].type === "BULK") {
    $.each(_form_data.line_items, function(_, item) {
      if (item.quantity > 100) {
        error_flg = true;
        const targetId = `error_${item.variant_id}`;

        error_msg_list.push({
          message: `${item.title}${validateQuantityLimitMessage}`,
          target: targetId
        });
      }
    });
  }


  let today = new Date(dateToYMD(new Date()));
  if(_order_type === "booking"){
    //ーーー売約の場合ーーー
    if(_bulk_order_flg_for_booking){
      let line_item_blank_flg = false,
          line_item_format_flg = false,
          line_item_past_date_flg = false;

      let blankCount = 0,
        formatCount = 0,
        pastDateCount = 0;

      for (let i = 0; i < _form_data.line_items.length; i++){
        let receiveDate = new Date(_form_data.line_items[i].receive_date);
        //取引予定日 (バルクオーダーのみ)
        if(_form_data.line_items[i].receive_date.length === 0){
          //ブランクチェック(既にエラーありの場合は飛ばす)
          // line_item_blank_flg = true;
          blankCount++;

          error_msg_list.push({
            message: "引取予定日" + error_msg_blank,
            target: 'properties[引取予定日]',
            lineItemKey: _form_data.line_items[i].variant_id
          });
        }else if((!rYYYY_MM_DD.test(_form_data.line_items[i].receive_date) || receiveDate == "Invalid Date") && _form_data.line_items[i].receive_date.length !== 0 ){
          //フォーマットチェック(既にエラーありの場合は飛ばす)
          // line_item_format_flg = true;
          formatCount++;
          error_msg_list.push({
            message: "引取予定日" + error_msg_format_YYYY_MM_DD,
            target: 'properties[引取予定日]',
            lineItemKey: _form_data.line_items[i].variant_id
          });
        } else if(receiveDate <= today) {
          // line_item_past_date_flg = true;
          pastDateCount++;
          error_msg_list.push({
            message: "引取予定日"+error_msg_past_day,
            target: 'properties[引取予定日]',
            lineItemKey: _form_data.line_items[i].variant_id
          });
        }
      }

      if (blankCount !== 0) {
        line_item_blank_flg = true;
      }
      if (formatCount !== 0) {
        line_item_format_flg = true;
      }
      if (pastDateCount !== 0) {
        line_item_past_date_flg = true;
      }

      if(line_item_blank_flg || line_item_format_flg || line_item_past_date_flg){
        error_flg = true;
      }
    }

    //専用伝票項目.貴社注文No
    if(!r0tZ.test(_form_data.order_number) && _form_data.order_number.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の貴社注文No" + error_msg_type_NumAZ, target: 'attributes[貴社注文No]' });
    }
    if(_form_data.order_number.length > 35){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の貴社注文No" + error_msg_length35, target: 'attributes[貴社注文No]' });
    }
    //専用伝票項目.製品No
    if(!r0tZ.test(_form_data.product_no) && _form_data.product_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の製品No"+error_msg_type_NumAZ, target: 'attributes[製品No]' });
    }
    if(_form_data.product_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の製品No" + error_msg_length10, target: 'attributes[製品No]' });
    }
    //専用伝票項目.コードNo
    if(!r0tZ.test(_form_data.contract_no) && _form_data.contract_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のコードNo" + error_msg_type_NumAZ, target: 'attributes[コードNo]' });
    }
    if(_form_data.contract_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のコードNo" + error_msg_length10, target: 'attributes[コードNo]' });
    }
    //専用伝票項目.ブランドCD
    if(_form_data.receipt_brand_code.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のブランドCD" + error_msg_length10, target: 'attributes[ブランドCD]' });
    }
    //専用伝票項目.ブランド名
    if(_form_data.brand_name.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のブランド名" + error_msg_length10, target: 'attributes[ブランド名]' });
    }
  }else{
    let bulkArriveDay = new Date(_form_data.bulk_arrive_day_plan);
    //ーーーそれ以外ーーー
    //無償カット情報.送付先の社会名
    if(_form_data.line_items[0].type === "BULK" && _form_data.bulk_sample_note.quantity != "0"){
      if(_form_data.bulk_sample_note.company_name.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "会社名が未入力です", target: 'attributes[会社名]' });
      }
      //無償カット情報.送付先の部署名
      //if(_form_data.bulk_sample_note.department.length == 0){
      // error_flg = true;
      //  error_msg_list.push("送付先の部署名"+error_msg_blank);
      //}
      //無償カット情報.担当者
      if(_form_data.bulk_sample_note.pic.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "担当者名が未入力です", target: 'attributes[担当者]' });
      }
      //無償カット情報.郵便番号
      if(_form_data.bulk_sample_note.post_code.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "郵便番号が未入力です", target: 'attributes[郵便番号]' });
      }
      //無償カット情報.都道府県
      if(_form_data.bulk_sample_note.prefectures.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "都道府県が未入力です", target: 'attributes[都道府県]' });
      }

      //無償カット情報.市区町村
      if(_form_data.bulk_sample_note.municipalities.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "市区町村が未入力です", target: 'attributes[市区町村]' });
      }
      //無償カット情報.住所
      if(_form_data.bulk_sample_note.address.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "住所が未入力です", target: 'attributes[住所]' });
      }
      //無償カット情報.建物名・部屋番号
      if(_form_data.bulk_sample_note.apartment.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "建物名・部屋番号が未入力です", target: 'attributes[apartment]' });
      }
      //無償カット情報.連絡番号
      if(_form_data.bulk_sample_note.phone_number.length == 0){
        error_flg = true;
        error_msg_list.push({ message: "連絡先番号が未入力です", target: 'attributes[連絡先番号]' });
      }
    }
    if(_form_data.bulk_sample_note.company_name.length > 40){
      error_flg = true;
      error_msg_list.push({ message: "送付先の社会名" + error_msg_length40, target: 'attributes[会社名]' });
    }
    //無償カット情報.送付先の部署名
    if(_form_data.bulk_sample_note.department.length > 40){
      error_flg = true;
      error_msg_list.push({ message: "送付先の部署名" + error_msg_length40, target: 'department_error' });
    }
    //無償カット情報.担当者
    if(_form_data.bulk_sample_note.pic.length > 40){
      error_flg = true;
      error_msg_list.push({ message: "送付先の担当者" + error_msg_length40, target: 'attributes[担当者]' });
    }
    //無償カット情報.郵便番号
    if(!r0t9.test(_form_data.bulk_sample_note.post_code) && _form_data.bulk_sample_note.post_code.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "送付先の郵便番号" + error_msg_type_Num, target: 'attributes[郵便番号]' });
    }
    if(_form_data.bulk_sample_note.post_code.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "送付先の郵便番号" + error_msg_length10, target: 'attributes[郵便番号]' });
    }
    //無償カット情報.都道府県
    if(!r0tZ.test(_form_data.bulk_sample_note.prefectures) && _form_data.bulk_sample_note.prefectures.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "送付先の都道府県" + error_msg_type_NumAZ, target: 'attributes[都道府県]' });
    }
    // attributes[都道府県]  attributes[郵便番号]
    if (_form_data.bulk_sample_note.post_code.length !== 0 && _form_data.bulk_sample_note.post_code.length < 10) {
      let checkValidate = await handleValidateProvince(_form_data.bulk_sample_note.post_code, _form_data.bulk_sample_note.prefectures);
      if (!checkValidate) {
        error_flg = true;
        error_msg_list.push({ message: "郵便番号と都道府県名が一致しません", target: 'attributes[都道府県]' });
        error_msg_list.push({ message: "郵便番号と都道府県名が一致しません", target: 'attributes[郵便番号]' });
      }
    }

    //無償カット情報.市区町村
    if(_form_data.bulk_sample_note.municipalities.length > 40){
      error_flg = true;
      error_msg_list.push({ message: "送付先の市区町村" + error_msg_length40, target: 'attributes[市区町村]' });
    }
    //無償カット情報.住所
    if(_form_data.bulk_sample_note.address.length > 60){
      error_flg = true;
      error_msg_list.push({ message: "送付先の住所" + error_msg_length60, target: 'attributes[住所]' });
    }
    //無償カット情報.建物名・部屋番号
    if(_form_data.bulk_sample_note.apartment.length > 40){
      error_flg = true;
      error_msg_list.push({ message: "送付先の建物名・部屋番号" + error_msg_length40, target: 'attributes[apartment]' });
    }
    //無償カット情報.連絡番号
    if(!r0t9.test(_form_data.bulk_sample_note.phone_number) && _form_data.bulk_sample_note.phone_number.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "送付先の連絡先番号" + error_msg_type_Num, target: 'attributes[連絡先番号]' });
    }
    if(_form_data.bulk_sample_note.phone_number.length > 30){
      error_flg = true;
      error_msg_list.push({ message: "送付先の連絡先番号" + error_msg_type_Num, target: 'attributes[連絡先番号]' });
    }
    //無償カット情報.備考
    if(_form_data.bulk_sample_note.note.length > 125){
      error_flg = true;
      error_msg_list.push({ message: "送付先の備考" + error_msg_length125, target: 'note_error' });
    }
    //専用伝票項目.貴社注文No
    if(!r0tZ.test(_form_data.order_number) && _form_data.order_number.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の貴社注文No" + error_msg_type_NumAZ, target: 'attributes[貴社注文No]' });
    }
    if(_form_data.order_number.length > 35){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の貴社注文No" + error_msg_length35, target: 'attributes[貴社注文No]' });
    }
    //専用伝票項目.製品No
    if(!r0tZ.test(_form_data.product_no) && _form_data.product_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の製品No" + error_msg_type_NumAZ, target: 'attributes[製品No]' });
    }
    if(_form_data.product_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目の製品No" + error_msg_length10, target: 'attributes[製品No]' });
    }
    //専用伝票項目.コードNo
    if(!r0tZ.test(_form_data.contract_no) && _form_data.contract_no.length !== 0){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のコードNo" + error_msg_type_NumAZ, target: 'attributes[コードNo]' });
    }
    if(_form_data.contract_no.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のコードNo" + error_msg_length10, target: 'attributes[コードNo]' });
    }
    //専用伝票項目.ブランドCD
    if(_form_data.receipt_brand_code.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のブランドCD" + error_msg_length10, target: 'attributes[ブランドCD]' });
    }
    //専用伝票項目.ブランド名
    if(_form_data.brand_name.length > 10){
      error_flg = true;
      error_msg_list.push({ message: "専用伝票項目のブランド名" + error_msg_length10, target: 'attributes[ブランド名]' });
    }
  }

  let companyBrands = window.localStorage.getItem('current_list_brands') ?? "[]";
  companyBrands = JSON.parse(companyBrands);
  if (_form_data.brand_code.length == 0 && _form_data.company_code != companyRepresentativeGlobal && companyBrands.length > 0) {
    error_flg = true;
    error_msg_list.push({ message: "ブランド名が未入力です", target: 'attributes[ブランドコード]' });
  }

  if(_form_data.line_items[0].type === "CUT" || (_form_data.line_items[0].type === "BULK" && _order_type === "draft" )) {
    //顧客注文No
    validateBlankReceptData(_receipt_items, "顧客注文No", _form_data.order_number, 'attributes[貴社注文No]');
    //製品No
    validateBlankReceptData(_receipt_items, "製品No", _form_data.product_no, 'attributes[製品No]');
    //コードNo
    validateBlankReceptData(_receipt_items, "コードNo", _form_data.contract_no, 'attributes[コードNo]');
    //ブランドCD
    validateBlankReceptData(_receipt_items, "ブランドCD", _form_data.receipt_brand_code, 'attributes[ブランドCD]');
    //ブランド名
    validateBlankReceptData(_receipt_items, "ブランド名", _form_data.brand_name, 'attributes[ブランド名]');
  }

  let formData = $('form').serializeArray().reduce(function(obj, item) {
    obj[item.name] = item.value;
    return obj;
  }, {});
  if(_order_type !== "booking"){
    // validate shipping address
    await validateShippingAddress(formData, error_msg_list);
    // validate billing address
    validateBillingAddress(formData, error_msg_list);
  }

  if (error_msg_list.length > 0) {
    error_flg = true
  }

  return {is_error:error_flg,error_msg:error_msg_list};
}

const validateShippingAddress = async (formData, error_msg_list) => {
  let orderType = formData['attributes[オーダーの種類]'];
  if (orderType == 'DIGITAL') {
    return
  }

  const provinceCodeInput = document.querySelector('#checkout_shipping_address_province_code');
  const autoFilledProvinceCode = provinceCodeInput ? provinceCodeInput.getAttribute('data-province-code') : null;

  const data = {
    last_name: formData['attributes[_shipping_address][last_name]'] ?? "",
    first_name: formData['attributes[_shipping_address][first_name]'] ?? "",
    company: formData['attributes[_shipping_address][company]'] ?? "",
    phone: formData['attributes[_shipping_address][phone]'] ?? "",
    zip: formData['attributes[_shipping_address][zip]'] ?? "",
    province: formData['attributes[_shipping_address][province]'] ?? "",
    province_code: formData['attributes[_shipping_address][province_code]'] ?? "",
    city: formData['attributes[_shipping_address][city]'] ?? "",
    address1: formData['attributes[_shipping_address][address1]'] ?? "",
  };
  let suffix_message = "は、必ず指定してください。";

  if (data.first_name.trim().length == 0) {
    error_msg_list.push({ message: "氏名（名）が未入力です", target: 'attributes[_shipping_address][first_name]' });
  }

  if (data.last_name.trim().length == 0){
    error_msg_list.push({ message: "氏名（姓）が未入力です", target: 'attributes[_shipping_address][last_name]' });
  }

  if (data.company.trim().length == 0) {
    error_msg_list.push({ message: "会社名/学校名が未入力です", target: 'attributes[_shipping_address][company]' });
  }

  if (data.zip.trim().length == 0) {
    error_msg_list.push({ message: "郵便番号が未入力です", target: 'attributes[_shipping_address][zip]' });
  }

  if (data.province.trim().length == 0 || data.province_code.trim().length == 0) {
    error_msg_list.push({ message: "都道府県が未入力です", target: 'attributes[_shipping_address][province_code]' });
  }

  if (data.city.trim().length !== 0) {
    let checkShippingValid = await handleValidateProvinceShipping(data.zip.trim(), data.province_code.trim());
    if (!checkShippingValid) {
      error_msg_list.push({ message: "郵便番号と都道府県名が一致しません", target: 'attributes[_shipping_address][province_code]' });
      error_msg_list.push({ message: "郵便番号と都道府県名が一致しません", target: 'attributes[_shipping_address][zip]' });
    }
  }

  if (data.city.trim().length == 0) {
    error_msg_list.push({ message: "市区町村が未入力です", target: 'attributes[_shipping_address][city]' });
  }

  if (data.address1.trim().length == 0) {
    error_msg_list.push({ message: "住所が未入力です", target: 'attributes[_shipping_address][address1]' });
  }

  if (data.phone.trim().length == 0) {
    error_msg_list.push({ message: "連絡先番号が未入力です", target: 'attributes[_shipping_address][phone]' });
  }
  let regexPhone = /^[0-9+-]+$/;
  if (!regexPhone.test(data.phone) && data.phone.length != 0){
    error_msg_list.push({ message: "連絡先番号は半角数字、ハイフン、プラスで入力してください。", target: 'attributes[_shipping_address][phone]' });
  }

  let regexZip = /^(?:\d{3}-?\d{4})$/;
  if (!regexZip.test(data.zip.trim()) && data.zip.trim().length != 0){
    error_msg_list.push({ message: "正しい郵便番号を入力してください。", target: 'attributes[_shipping_address][zip]' });
  }

}

const validateBillingAddress = (formData, error_msg_list) => {
  let companyCode = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "";
  let isCompanyRepresentative = companyRepresentativeGlobal == companyCode;
  if (isCompanyRepresentative) {
    return
  }
  const data = {
    last_name: formData['attributes[_billing_address][last_name]'] ?? "",
    first_name: formData['attributes[_billing_address][first_name]'] ?? "",
  };

  if (data.last_name.trim().length == 0){
    error_msg_list.push({ message: "氏名（姓）が未入力です", target: 'attributes[_billing_address][last_name]' });
  }

  if (data.first_name.trim().length == 0){
    error_msg_list.push({ message: "氏名（名）が未入力です", target: 'attributes[_billing_address][first_name]' });
  }

}

// 2022.6.25 Add Start Function:Access API
const checkoutOrder = (e,_order_type)=>{
  openFilterLoading();
  let receipt_items = window.localStorage.hasOwnProperty('current_company_receipt_items') ? JSON.parse(window.localStorage.getItem('current_company_receipt_items')) : [];
  e.preventDefault();
  //2022.07.12 バリデーション保留
  let idError =  _order_type == 'booking' ? '#c-ErrorMsg-booking' : '#c-ErrorMsg';
  const errorElem =document.querySelector(idError);
  errorElem.innerHTML = "";

  let form_wrapper = "#non-bookingOrder"

  if(e.target.dataset.cart_type === "BULK" && _order_type === "booking"){
    form_wrapper = "#bookingOrder"
  }

  //①以下項目を取得
  const customer_id = e.target.dataset.customer_id,
      company_code = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "",
      order_items = cart_items,
      order_items_metafields = JSON.parse(e.target.dataset.line_items_type),
      note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄]"]`)?.value,
      use_purpose = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`).value : "",
      offer_company = document.querySelector(`${form_wrapper} [name="attributes[見本帳提案先]"]`).value,
      planning_season = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`).value : "",
      planning_season_note = document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`) ? document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`).value : "",
      request_time = document.querySelector(`${form_wrapper} [name="attributes[現物必要時期]"]`).value.replace("月頃",""),
      quantity = document.querySelector(`${form_wrapper} input[type="radio"][name="quantity[quantity]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[quantity]"]:checked`).value : "",
      company_name = document.querySelector(`${form_wrapper} [name="attributes[会社名]"]`).value,
      department = document.querySelector(`${form_wrapper} [name="attributes[department]"]`)?.value ?? "",
      pic = document.querySelector(`${form_wrapper} [name="attributes[担当者]"]`).value,
      post_code = document.querySelector(`${form_wrapper} [name="attributes[郵便番号]"]`).value,
      prefectures = document.querySelector(`${form_wrapper} [name="attributes[都道府県]"]`).value,
      municipalities = document.querySelector(`${form_wrapper} [name="attributes[市区町村]"]`).value,
      address = document.querySelector(`${form_wrapper} [name="attributes[住所]"]`).value,
      apartment = document.querySelector(`${form_wrapper} [name="attributes[apartment]"]`)?.value ?? "",
      phone_number = document.querySelector(`${form_wrapper} [name="attributes[連絡先番号]"]`).value,
      bulk_sample_note_note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄（落とし）]"]`)?.value ?? "",
      credit_card_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[credit_card_check]"]`)?.checked ?? "",
      np_payment_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[np_payment_check]"]`)?.checked ?? "",
      weekend_arrive_plan = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[土着希望の場合はチェックを入れてください]"]`)?.checked,
      mail_alert = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[商品が出荷されたらメールにて通知を受け取る]"]`).checked,
      receipt_item_order_no = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[貴社注文No]"]`).value.trim() : "",
      receipt_item_product_no = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[製品No]"]`).value.trim() : "",
      receipt_item_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ?  document.querySelector(`${form_wrapper} [name="attributes[コードNo]"]`).value.trim() : "",
      //2022.08.01 Modify 「receipt_item_brand_code・receipt_item_brand_name」取得方法を変更
      // receipt_item_brand_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).value : "",
      // receipt_item_brand_name = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelectorAll(`${form_wrapper} [name="attributes[ブランド名]"] option`)[document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`).selectedIndex].textContent : "",
      brand_code = document.querySelector(`${form_wrapper} [name="attributes[ブランドコード]"]`)?.value ?? "",
      receipt_item_brand_code = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランドCD]"]`)?.value.trim(): "",
      receipt_item_brand_name = e.target.dataset.cart_type === "BULK" || e.target.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`)?.value.trim(): "",
      cart_token = e.target.dataset.cart_token,

      discountCode = document.getElementById('input_discount_code') ? document.getElementById('input_discount_code').value : null;
  let bulk_arrive_day_plan = e.target.dataset.cart_type === "BULK" ? document.querySelector(`${form_wrapper} [name="attributes[希望着日]"]`).value : "";
  if (e.target.dataset.cart_type === "CUT" && weekend_arrive_plan) {
    let now = new Date();
    let nextSaturday = new Date(now.setDate(now.getDate() + (((6 + 7 - now.getDay()) % 7) || 7)));
    bulk_arrive_day_plan = dateToYMD(nextSaturday);
  }

  //②Metafield項目取得用の配列を生成
  let metafields_forsearch = [];
  order_items_metafields.forEach((item)=>{
    metafields_forsearch.push({
      id:item.split("::")[0],
      digital_type:item.split("::")[1],
      unit:item.split("::")[2],
      //digital_color_additional:item.split("::")[3] ? JSON.parse(item.split("::")[3]) : {},
      // print_digital_image:item.split("::")[4]
    })
  });

  //③formデータ line_items配列を生成
  let line_items = [];
  let bulk_order_flg_for_booking = false;
  //押下ボタンで分岐
  if(_order_type === "booking"){
    //売約の場合
    order_items.forEach((item)=>{
      if(order_items[0].properties._type === "BULK"){
        //BULKオーダーの場合、フラグON(売約バリデーション用)
        bulk_order_flg_for_booking = true;
      }
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        receive_date : order_items[0].properties._type !== "BULK" ? "" : document.querySelector(`#CartItem--${item.id} [name="properties[引取予定日]"]`) ? document.querySelector(`#CartItem--${item.id} [name="properties[引取予定日]"]`).value : "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`) ? document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`).value : "",
        quantity:item.quantity,
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"" //2022.07.12 制限
      })
    });
  }else{
    //それ以外
    order_items.forEach((item)=>{
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        booking_order_web_id: (item.properties && item.properties['_Booking web id']) ? item.properties['_Booking web id'] : "",
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        //2022.10.02 修正
        // quantity:item.properties?.type === "CUT" ? Number(item.quantity)  : item.quantity,
        quantity:item.properties?._type === "CUT" || (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? Number(item.quantity)  : item.quantity,
        type: item.properties?._type ? item.properties._type : "",
        digital_type: metafields_forsearch.find((v) => v.id == item.id) ? metafields_forsearch.find((v) => v.id == item.id).digital_type : "",
        is_default_color: item?.properties?._is_default_color,
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        design_for: item.properties?._design_for || null,
        variant_design_id: (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? item?.properties?._design_variant_id.toString() : null,
        print_digital_image:  item.properties?._print_digital_image || "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`) ? document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`).value : "",
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"", //2022.07.12 制限
        variant_title: item.variant_title || '',
        is_apply_free_for_default_color: item.properties?._is_apply_free_for_default_color || false,
        sap_product_id: item.properties?._sap_product_id || '',
      })
    });
  }

  //④API用ヘッダー・formデータを生成
  const myHeaders = {
    "Content-Type": "application/json;charset=utf-8"
  }

  let formdata = {};

  //押下ボタンで分岐
  if(_order_type === "booking"){
    //売約の場合
    formdata = {
      "customer_id":customer_id,
      "company_code":company_code,
      "brand_code":brand_code,
      "line_items":line_items,
      "note":note,
      "mail_alert":order_items[0].properties._type === "CATALOG" || order_items[0].properties._type === "PRINT" ? "0" : mail_alert ? "1" : "0",
      "order_number":receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no":receipt_item_code,
      "receipt_brand_code":receipt_item_brand_code,
      "brand_name":receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name
    };
  }else{
    //それ以外
    formdata = {
      "customer_id":customer_id,
      "company_code":company_code,
      "brand_code":brand_code,
      "cart_token":cart_token,
      "line_items":line_items,
      "note":note,
      "sample_book_note":{
        "use_purpose":use_purpose === "自社ブランドで使用" ? "1" : use_purpose === "他社提案用（提案先を入力して下さい）" ? "2" : "",
        "offer_company":offer_company,
        "planning_season":planning_season === "期中生産" ? "1" : planning_season === "計画生産" ? "2" : planning_season === "展示会用" ? "3" : planning_season === "その他" ? "4" : "",
        "planning_season_note": planning_season_note,
        "request_time":request_time
      },
      "bulk_sample_note":{
        "quantity":quantity === "不要" ? "0" : quantity === "0.1M" ? "1" : quantity === "0.2M" ? "2" : quantity === "0.3M" ? "3" : "0",
        "company_name":company_name,
        "department":department,
        "pic":pic,
        "post_code":post_code,
        "prefectures":prefectures,
        "municipalities":municipalities,
        "address":address,
        "apartment":apartment,
        "phone_number":phone_number,
        "note":bulk_sample_note_note.replace(/\n/g,' ')
      },
      "credit_card_check": line_items[0].type === "BULK" && credit_card_check ? "1" : "0",
      "np_payment_check": line_items[0].type === "BULK" && np_payment_check ? "1" : "0",
      "bulk_arrive_day_plan":bulk_arrive_day_plan,
      "weekend_arrive_plan":line_items[0].type === "BULK" ? "0" : weekend_arrive_plan ? "1" : "0",
      "mail_alert":line_items[0].type === "CATALOG" || line_items[0].type === "DIGITAL" ? "0" : mail_alert ? "1" : "0",
      "order_number":receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no":receipt_item_code,
      "receipt_brand_code":receipt_item_brand_code,
      "brand_name":receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name,
      "discount_code": discountCode?.trim(),
    };
  }

(async () => {
  //⑤バリデーション
  const valid_result = await  validateData(formdata,_order_type,bulk_order_flg_for_booking, receipt_items);
  document.querySelectorAll('.error-message').forEach((error) => error.remove());
  document.querySelectorAll('.block-error-message').forEach((errorBlock) => {
    errorBlock.style.display = 'none';
  });


  if(valid_result.is_error){
    //エラーありの場合
    //エラー表示
    const displayedTargets = new Set(); // To track which targets have already displayed their messages
    let firstErrorElement = null;
    
    valid_result.error_msg.forEach(({ message, target, lineItemKey = null }) => {
      let errorElement;

      // Tìm phần tử lỗi theo target
      errorElement = document.querySelector(`[name="${target}"]`);

      // Nếu là dạng BULK, giới hạn trong container `#non-bookingOrder`
      if (formdata.line_items[0].type === 'BULK') {
        const container = document.querySelector('#non-bookingOrder');
        errorElement = container.querySelector(`[name="${target}"]`);
      }

      if (errorElement) {
        let parentElement;
        let errorSpan;

        if (target === 'attributes[用途]' && formdata.line_items[0].type === 'CATALOG') {
          parentElement = errorElement.closest('.custom-order-number');
        } else if (target === 'attributes[生産時期]' && formdata.line_items[0].type === 'CATALOG') {
          parentElement = errorElement.closest('.custom-order-number');
        } else if (target === 'attributes[希望着日]') {
          parentElement = errorElement.closest('p');
        } else if (target === 'properties[引取予定日]' && _order_type === 'booking') {
          parentElement = errorElement.closest('.date_time');
        }
        else {
          parentElement = errorElement.parentNode;
        }

        let errorBlock = null
        if (lineItemKey != null) {
          errorBlock = document.querySelector(`#error_${lineItemKey}`);
        }
        if (errorBlock) {
          const errorContent = errorBlock.querySelector('.error');
          if (errorContent) {
            errorContent.textContent = message;
            errorBlock.style.display = 'block';
          }
          if (!firstErrorElement) {
            firstErrorElement = parentElement;
          }

          displayedTargets.add(target);
        } else {
          if (parentElement) {
            errorSpan = parentElement.querySelector('.error-message');

            if (!errorSpan) {
              errorSpan = document.createElement('span');
              errorSpan.className = 'error-message';
              errorSpan.style.color = 'red';
              errorSpan.textContent = message;
              errorElement.style.marginBottom = '0px';

              if (target === 'attributes[希望着日]') {
                parentElement.parentNode.insertBefore(errorSpan, parentElement.nextSibling);
                const svgElement = document.querySelector('.cart-attribute__field .custom-date svg');
                if (svgElement) {
                  svgElement.style.top = '62%';
                }
              } else if (target === 'properties[引取予定日]' && _order_type === 'booking') {
                parentElement.after(errorSpan);
              } else {
                parentElement.appendChild(errorSpan);
              }
            }

            if (!firstErrorElement) {
              firstErrorElement = parentElement;
            }

            displayedTargets.add(target);
          }
        }
      }
    });

    if (firstErrorElement) {
      firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstErrorElement.focus();
    }

    valid_result.error_msg.forEach(({ message, target }) => {
      if (!displayedTargets.has(target)) {
        let errorList = document.createElement('li');
        errorList.innerHTML = message;
        errorElem.appendChild(errorList);
      }
    });
    cancelFilterLoading();
  }else{
    //エラーなしの場合
    // ⑥EndPointへアクセス
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        ...formdata,
        token:globalToken
      }),
      redirect: 'follow'
    };

    const endpoint = _order_type === "booking" ? "/apps/dev-1/booking-order" : "/apps/dev-1/draft-order";

    changeStatusButtonForm(true);

    fetch(endpoint, requestOptions)
        .then(response => response.json())
        .then(result => {
          if(result.errors){
            errorElem.innerHTML = `<span>
            申し訳ございませんが、ページを再読み込みしてから再度お試しください。<br />
            同じエラーが何度も出る場合は、お手数ですが一度カートを空にしていただき、商品をカートに追加するところからやり直していただけますでしょうか。
            </span>`;
            //Error
            Object.keys(result.errors).forEach((item_key)=>{
              result.errors[item_key].forEach((error_msg)=>{
                //エラー表示
                let errorList = document.createElement("li");
                errorList.innerHTML = item_key + "：" + error_msg;
                errorElem.appendChild(errorList);
              });
            });
            changeStatusButtonForm(false);
            cancelFilterLoading()
          }else{
            //Success
            if(_order_type !== "booking"){
              let paymentMethods = result?.data?.fabric_payment_method?.split(',').map(method => method.trim());
              if (result?.error_type == 'discount' && renderErrorDiscount) {
                renderErrorDiscount(result);
                changeStatusButtonForm(false);
                cancelFilterLoading();
              } else if(formdata.line_items[0].type === "BULK" && paymentMethods?.length == 1 && paymentMethods[0] == "クレジットカード" && formdata?.credit_card_check == "0") {
                let errorList = document.createElement("li");
                errorList.innerHTML = " 決済方法を選択してください。";
                errorElem.appendChild(errorList);
                changeStatusButtonForm(false);
                cancelFilterLoading();
              } else if(formdata.line_items[0].type === "BULK" && paymentMethods?.length == 1 && paymentMethods[0] == "NP掛払い" && formdata?.np_payment_check == "0") {
                let errorList = document.createElement("li");
                errorList.innerHTML = " 決済方法を選択してください。";
                errorElem.appendChild(errorList);
                changeStatusButtonForm(false);
                cancelFilterLoading();
              } else {
                //booking orderでない場合、受け取ったURLへ遷移
                if(result.data){
                  localStorage.removeItem('bulk_tab');
                  cancelFilterLoading();
                  location.href = result.data.draftOrderCreate.draftOrder.invoiceUrl + '?locale=ja';
                }
              }
            }

            if (_order_type === 'booking' && result.data) {
              localStorage.removeItem('receipt_items');
              // fetch('/cart/clear.js', { method: "POST" });
              $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                dataType: 'json',
                async: true,
                success: async function() { 
                  localStorage.removeItem('bulk_tab');
                  cancelFilterLoading();
                  await resetAttributeCart();
                  location.href = "/pages/booking-complete";
                },
              });
            }
          }
        })
        .catch(error => {
          console.log('error', error.errors);
          changeStatusButtonForm(false);
          cancelFilterLoading();
        });
  }
})();
}


function changeStatusButtonForm(isDisabled) {
  const buttonsFrom = document.querySelectorAll('form.Cart button');
  for (let i = 0; i < buttonsFrom.length; i++) {
    buttonsFrom[i].disabled = isDisabled;
  }
}
// 2022.6.25 Add End

// 2022.7.23 Add Start Display current_company on cart page
window.addEventListener('DOMContentLoaded', () => {
  const disp_current_company = document.querySelectorAll(".login_current_company");
  const current_company_name = window.localStorage.hasOwnProperty('current_company_name') ? window.localStorage.getItem('current_company_name') : "";
  if(disp_current_company && current_company_name) {
    disp_current_company.forEach((elem) => {
      elem.value = current_company_name;
    });
  }
})
// 2022.7.23 Add End


const prepareCheckoutButton = document.getElementById('prepareCheckout');
const cartFormEl = document.querySelector('#cart');

if (prepareCheckoutButton && cartFormEl) {
  prepareCheckoutButton.onclick = async function (e) {
    e.preventDefault();
    openFilterLoading();
    let form_wrapper = "#non-bookingOrder";
    let limitNumMeterForDiscountCut = 0.9;
    const customer_id = cartFormEl.dataset.customer_id,
        order_items = cart_items,
        company_code = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "",
        note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄]"]`)?.value,
        use_purpose = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[用途]"]:checked`).value : "",
        offer_company = document.querySelector(`${form_wrapper} [name="attributes[見本帳提案先]"]`) ? document.querySelector(`${form_wrapper} [name="attributes[見本帳提案先]"]`).value : "",
        planning_season = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[生産時期]"]:checked`).value : "",
        planning_season_note = document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`) ? document.querySelector(`${form_wrapper} [name="attributes[生産時期その他]"]`).value : "",
        request_time = document.querySelector(`${form_wrapper} [name="attributes[現物必要時期]"]`).value.replace("月頃",""),
        quantity = document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[quantity]"]:checked`) ? document.querySelector(`${form_wrapper} input[type="radio"][name="attributes[quantity]"]:checked`).value : "",
        company_name = document.querySelector(`${form_wrapper} [name="attributes[会社名]"]`).value,
        department = document.querySelector(`${form_wrapper} [name="attributes[department]"]`)?.value ?? "",
        pic = document.querySelector(`${form_wrapper} [name="attributes[担当者]"]`).value,
        post_code = document.querySelector(`${form_wrapper} [name="attributes[郵便番号]"]`).value,
        prefectures = document.querySelector(`${form_wrapper} [name="attributes[都道府県]"]`).value,
        municipalities = document.querySelector(`${form_wrapper} [name="attributes[市区町村]"]`).value,
        address = document.querySelector(`${form_wrapper} [name="attributes[住所]"]`).value,
        apartment = document.querySelector(`${form_wrapper} [name="attributes[apartment]"]`)?.value ?? "",
        phone_number = document.querySelector(`${form_wrapper} [name="attributes[連絡先番号]"]`).value,
        bulk_sample_note_note = document.querySelector(`${form_wrapper} [name="attributes[ご要望・コメント欄（落とし）]"]`)?.value ?? "",
        np_payment_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[np_payment_check]"]`)?.checked ?? "",
        weekend_arrive_plan = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[土着希望の場合はチェックを入れてください]"]`).checked,
        mail_alert = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[商品が出荷されたらメールにて通知を受け取る]"]`).checked,
        receipt_item_order_no = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[貴社注文No]"]`).value.trim() : "",
        receipt_item_product_no = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[製品No]"]`).value.trim() : "",
        receipt_item_code = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ?  document.querySelector(`${form_wrapper} [name="attributes[コードNo]"]`).value.trim() : "",
        brand_code = document.querySelector(`${form_wrapper} [name="attributes[ブランドコード]"]`)?.value ?? "",
        receipt_item_brand_code = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランドCD]"]`)?.value.trim(): "",
        receipt_item_brand_name = cartFormEl.dataset.cart_type === "BULK" || cartFormEl.dataset.cart_type === "CUT" ? document.querySelector(`${form_wrapper} [name="attributes[ブランド名]"]`)?.value.trim(): "",
        cart_token = cartFormEl.dataset.cart_token,
        discountCode = document.getElementById('input_discount_code') ? document.getElementById('input_discount_code').value : null,
        orderType = cartFormEl.dataset.cart_type;
    let credit_card_check = document.querySelector(`${form_wrapper} input[type="checkbox"][name="attributes[credit_card_check]"]`)?.checked ?? "";
    let totalOfPrice = 0;
    let balancePrice = 0;

    if (orderType == 'BULK' && isInHiddenTimePeriod()) {
      credit_card_check = "";
    }
    let bulk_arrive_day_plan = cartFormEl.dataset.cart_type === "BULK" ? document.querySelector(`${form_wrapper} [name="attributes[希望着日]"]`).value : "";
    if (cartFormEl.dataset.cart_type === "CUT" && weekend_arrive_plan) {
      let now = new Date();
      const nextSaturday = new Date(now.setDate(now.getDate() + (((6 + 7 - now.getDay()) % 7) || 7)));
      bulk_arrive_day_plan = dateToYMD(nextSaturday);
      document.querySelector(`${form_wrapper} [name="attributes[希望着日]"]`).value = bulk_arrive_day_plan;
    }
    let line_items = [];
    let error_catalog_message = [];
    order_items.forEach((item)=>{
      line_items.push({
        parent_product_id: String((item.sku).slice(0, 11).toUpperCase()),
        booking_order_web_id: (item.properties && item.properties['Booking web id']) ? item.properties['Booking web id'] : "",
        product_id:String(item.product_id),
        variant_id:String(item.variant_id),
        //2022.10.02 修正
        // quantity:item.properties?.type === "CUT" ? Number(item.quantity)  : item.quantity,
        quantity:item.properties?._type === "CUT" || (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? Number(item.quantity)  : item.quantity,
        type: item.properties?._type ? item.properties._type : "",
        digital_type: '3D',
        is_default_color: item?.properties?._is_default_color,
        title: item.product_title,
        sku: item.sku ? item.sku : "",
        design_for: item.properties?._design_for || null,
        variant_design_id: (item.properties?._type === "PRINT" && item.properties?._print_digital_image) ? item?.properties?._design_variant_id.toString() : null,
        print_digital_image:  item.properties?._print_digital_image || "",
        company_item_code : document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`) ? document.querySelector(`#CartItem--${item.id} [data-name="company_item_code"]`).value : "",
        slip_no:"", //2022.07.12 制限
        slip_note:"", //2022.07.12 制限
        season:"", //2022.07.12 制限
        mixing_ratio:"", //2022.07.12 制限
        color:"", //2022.07.12 制限
        size:"", //2022.07.12 制限
        variant_title: item.variant_title || '',
        is_apply_free_for_default_color: item.properties?._is_apply_free_for_default_color || false,
        sap_product_id: item.properties?._sap_product_id || '',
        handle: item.handle ? item.handle : ""
      });
      if (orderType == 'CUT' && item.handle != 'balance' && item.handle != 'deposit' && isSpecialCompanyForDiscountCutOrder && (item.quantity / 10) > limitNumMeterForDiscountCut){
        item.properties._price_company = Math.floor(item?.properties._price_by_m/10);
        item.properties._original_price_company = item?.properties._price_by_m;
      } else if (orderType == 'CUT' && item.handle != 'balance' && item.handle != 'deposit' && isSpecialCompanyForDiscountCutOrder && (item.quantity / 10) <= limitNumMeterForDiscountCut){
        item.properties._price_company = 0;
        item.properties._original_price_company = 0;
      }
      if (orderType == 'BULK' && item.handle != 'deposit' && item.handle != 'balance') {
        totalOfPrice += (item.properties?._price_company || 0) * item.quantity;
        balancePrice += Math.floor((item.properties?._original_price_company * item.properties?._base_unit *  item.quantity) - (item.properties?._price_company * item.quantity));
      }
      if ((orderType == 'CUT' || orderType == 'PRINT')
          && item.properties?._has_custom_price
          && (item.properties?._price_company * 10 != item.properties?._original_price_company)
          && item.handle != 'balance' && item.handle != 'deposit') {
        balancePrice += Math.floor((item.properties?._original_price_company - item.properties?._price_company * 10) * item.quantity / 10);
      }
      if (orderType == 'CATALOG' && item.properties?._price_company == 0 && item.quantity > 1) {
        error_catalog_message.push({
          message: `${item.product_title}の数量がオーダー上限を超えています`,
          target: `error_${String(item.product_id)}`
        });
      }
    });

    //それ以外
    let formdata = {
      "customer_id": customer_id,
      "company_code": company_code,
      "brand_code": brand_code,
      "cart_token": cart_token,
      "line_items": line_items,
      "note": note,
      "sample_book_note": {
        "use_purpose": use_purpose === "自社ブランドで使用" ? "1" : use_purpose === "他社提案用（提案先を入力して下さい）" ? "2" : "",
        "offer_company": offer_company,
        "planning_season": planning_season === "期中生産" ? "1" : planning_season === "計画生産" ? "2" : planning_season === "展示会用" ? "3" : planning_season === "その他" ? "4" : "",
        "planning_season_note": planning_season_note,
        "request_time": request_time
      },
      "bulk_sample_note": {
        "quantity": quantity || 0,
        "company_name": company_name,
        "department": department,
        "pic": pic,
        "post_code": post_code,
        "prefectures": prefectures,
        "municipalities": municipalities,
        "address": address,
        "apartment": apartment,
        "phone_number": phone_number,
        "note": bulk_sample_note_note.replace(/\n/g,' ')
      },
      "credit_card_check": line_items[0].type === "BULK" && credit_card_check ? "1" : "0",
      "np_payment_check": line_items[0].type === "BULK" && np_payment_check ? "1" : "0",
      "bulk_arrive_day_plan": bulk_arrive_day_plan,
      "weekend_arrive_plan": line_items[0].type === "BULK" ? "0" : weekend_arrive_plan ? "1" : "0",
      "mail_alert": line_items[0].type === "CATALOG" || line_items[0].type === "DIGITAL" ? "0" : mail_alert ? "1" : "0",
      "order_number": receipt_item_order_no,
      "product_no": receipt_item_product_no,
      "contract_no": receipt_item_code,
      "receipt_brand_code": receipt_item_brand_code,
      "brand_name": receipt_item_brand_name === "選択してください" ? "" : receipt_item_brand_name,
      "discount_code": discountCode?.trim(),
    }

    const errorElem =document.querySelector('#c-ErrorMsg');
    errorElem.innerHTML = "";
    let receipt_items = window.localStorage.hasOwnProperty('current_company_receipt_items')
        ? JSON.parse(window.localStorage.getItem('current_company_receipt_items')) : [];

(async () => {        
    let valid_result = await  validateData(formdata, 'draft', false, receipt_items);
    if (error_catalog_message.length > 0) {
      valid_result.is_error = true;
      valid_result.error_msg = valid_result.error_msg.concat(error_catalog_message);
    }
    document.querySelectorAll('.block-error-message').forEach((errorBlock) => {
      errorBlock.style.display = 'none';
    });
    document.querySelectorAll('.error-message').forEach((error) => error.remove());
    try {
      if(valid_result.is_error){
        //エラーありの場合
        //エラー表示
        const displayedTargets = new Set(); // To track which targets have already displayed their messages
        let firstErrorElement = null;

        valid_result.error_msg.forEach(({ message, target }) => {
          let errorElement;
          errorElement = document.querySelector(`[name="${target}"]`);
          if (formdata.line_items[0].type === 'BULK') {
            const container = document.querySelector('#non-bookingOrder');
            errorElement = container.querySelector(`[name="${target}"]`);
          }
        
          if (errorElement) {
            let parentElement;
            let errorSpan;

            if (target === 'attributes[用途]' && formdata.line_items[0].type === 'CATALOG') {
              parentElement = errorElement.closest('.custom-order-number');
            } else if (target === 'attributes[生産時期]' && formdata.line_items[0].type === 'CATALOG') {
              parentElement = errorElement.closest('.custom-order-number');
            } else if (target === 'attributes[希望着日]') {
              parentElement = errorElement.closest('p');
            } else {
              parentElement = errorElement.parentNode;
            }

            if (parentElement) {
              errorSpan = parentElement.querySelector('.error-message');
        
              if (!errorSpan) {
                errorSpan = document.createElement('span');
                errorSpan.className = 'error-message';
                errorSpan.style.color = 'red';
                errorSpan.textContent = message;
                errorElement.style.marginBottom = '0px';

                if (target === 'attributes[希望着日]') {
                  parentElement.parentNode.insertBefore(errorSpan, parentElement.nextSibling);
                  const svgElement = document.querySelector('.cart-attribute__field .custom-date svg');
                  if (svgElement) {
                    svgElement.style.top = '62%';
                  }
                } else {
                  parentElement.appendChild(errorSpan);
                }
              }

              if (!firstErrorElement) {
                firstErrorElement = parentElement;
              }

              displayedTargets.add(target);
            }
          }
        });

        const errorMessages = document.querySelectorAll('.error-message');

        if (errorMessages.length > 0) {
          const firstErrorElement = errorMessages[0].closest('.error-message').parentElement;
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstErrorElement.focus();
        } else {
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorElement.focus();
          }
        }

        valid_result.error_msg.forEach(({ message, target }) => {
          if (!displayedTargets.has(target)) {
            let errorList = document.createElement('li');
            errorList.innerHTML = message;
            errorElem.appendChild(errorList);
          }
        });
        cancelFilterLoading();
        e.preventDefault();
        return false;
      }else{
        if (!isValidSubmitPrint) {
          return;
        }
        await removeAdditionalFeeItem();
        let additionalItem = null;
        let additionalItemBalance = null;
        if (line_items[0].type === "BULK") {
          let hasDepositItem = false;
          if (credit_card_check) {
            document.querySelector('input[name="attributes[_payment_methods]"]').value = JSON.stringify([{name: "Shopify Payments"}]);
            hasDepositItem = true;
          } else if (np_payment_check) {
            document.querySelector('input[name="attributes[_payment_methods]"]').value = JSON.stringify([{name: "NP掛け払い（法人向け請求書払い）"}]);
            hasDepositItem = true;
          }
          if (hasDepositItem) {
            additionalItem = await getDepositItem(totalOfPrice);
          } else {
            // Remove credit card payment and NP payment method when not hasDepositItem
            const paymentsAllowString = document.querySelector('input[name="attributes[_payment_methods]"]').value;
            const paymentsAllowArray = JSON.parse(paymentsAllowString);
            const paymentsAllow = paymentsAllowArray.filter((item) => (item.name !== 'Shopify Payments' && item.name !== 'NP掛け払い（法人向け請求書払い）'));
            document.querySelector('input[name="attributes[_payment_methods]"]').value = JSON.stringify(paymentsAllow);
          }
        }

        if ((orderType == 'CUT' || orderType == 'PRINT' || orderType == 'BULK') && balancePrice > 0) {
          try {
            additionalItemBalance = await getBalanceItem(orderType, balancePrice);
          } catch (error) {
            console.error('Error 2:', error);
            e.preventDefault();
            return false;
          }
        }

        let formDataSubmit = $('form').serializeArray().reduce(function(obj, item) {
          obj[item.name] = item.value;
          return obj;
        }, {});

        const {isError, message} = await handleShippingAddress(customer_id, formDataSubmit);
        if (isError) {
          let errorList = document.createElement("li");
          errorList.innerHTML = message;
          errorElem.appendChild(errorList);
          cancelFilterLoading();
          e.preventDefault();
          return false;
        }
        await handleBillingAddress();
        const checkcartItems = await getCartItems();
        if (checkcartItems.length == 0) {
          window.location.href= '/collections/stock-available';
        }
        await updateAttributesAndReOrderLineItem(orderType, additionalItem, additionalItemBalance);
        localStorage.removeItem('bulk_tab');
      }
    } catch (error) {
      cancelFilterLoading();
      console.log(error);
      e.preventDefault();
      return false;
    }
})();
  }
}


function handleBillingAddress() {
  let companyCode = window.localStorage.hasOwnProperty('current_company') ? window.localStorage.getItem('current_company') : "";
  let isCompanyRepresentative = companyRepresentativeGlobal == companyCode;
  if (isCompanyRepresentative) {
    const shippingAddress = {
      last_name: document.getElementById('checkout_shipping_address_last_name')?.value ?? "",
      first_name: document.getElementById('checkout_shipping_address_first_name')?.value ?? "",
      company: document.getElementById('checkout_shipping_address_company')?.value ?? "",
      department: document.getElementById('checkout_shipping_address_dept')?.value ?? "",
      zip: document.getElementById('checkout_shipping_address_zip')?.value ?? "",
      province_code: document.getElementById('checkout_shipping_address_province_code')?.value ?? "",
      province: document.getElementById('checkout_shipping_address_province')?.value ?? "",
      city: document.getElementById('checkout_shipping_address_city')?.value ?? "",
      address1: document.getElementById('checkout_shipping_address_address1')?.value ?? "",
      address2: document.getElementById('checkout_shipping_address_address2')?.value ?? "",
      phone: document.getElementById('checkout_shipping_address_phone')?.value ?? "",
      country: document.getElementById('checkout_shipping_address_country')?.value ?? "",
    }

    const billingForm = {
      last_name: document.getElementById('checkout_billing_address_last_name'),
      first_name: document.getElementById('checkout_billing_address_first_name'),
      company: document.getElementById('checkout_billing_address_company'),
      department: document.getElementById('checkout_billing_address_dept'),
      zip: document.getElementById('checkout_billing_address_zip'),
      province_code: document.getElementById('checkout_billing_address_province_code'),
      province: document.getElementById('checkout_billing_address_province'),
      city: document.getElementById('checkout_billing_address_city'),
      address1: document.getElementById('checkout_billing_address_address1'),
      address2: document.getElementById('checkout_billing_address_address2'),
      phone: document.getElementById('checkout_billing_address_phone'),
    }

    billingForm.last_name.value = shippingAddress?.last_name ?? "";
    billingForm.first_name.value = shippingAddress?.first_name ?? "";
    billingForm.company.value = shippingAddress?.company ?? "";
    billingForm.department.value = shippingAddress?.department ?? "";
    billingForm.zip.value = shippingAddress?.zip ?? "";
    billingForm.province_code.value = shippingAddress?.province_code ?? "";
    billingForm.province.value =shippingAddress?.province ?? "";
    billingForm.city.value = shippingAddress?.city ?? "";
    billingForm.address1.value = shippingAddress?.address1 ?? "";
    billingForm.address2.value = shippingAddress?.address2 ?? "";
    billingForm.phone.value = shippingAddress?.phone ?? "";
  }
}


async function handleShippingAddress(customer_id, formData) {
  const provinceCode = formData['attributes[_shipping_address][province_code]'];
  const dataUpsertAddress = {
    last_name: formData['attributes[_shipping_address][last_name]'] ?? "",
    first_name: formData['attributes[_shipping_address][first_name]'] ?? "",
    company: formData['attributes[_shipping_address][company]'] ?? "",
    phone: formData['attributes[_shipping_address][phone]'] ?? "",
    zip: formData['attributes[_shipping_address][zip]'] ?? "",
    province: provinceShopify[provinceCode]?.value ?? "",
    province_code: provinceCode ?? "",
    city: formData['attributes[_shipping_address][city]'] ?? "",
    address1: formData['attributes[_shipping_address][address1]'] ?? "",
    address2: formData['attributes[_shipping_address][address2]'] ?? "",
    default: 1,
    department: formData['attributes[_shipping_address][department]'] ?? "",
    shopify_customer_id: customer_id,
    customer_id : customer_id,
    token: globalToken,
  };
  
  let orderType = formData['attributes[オーダーの種類]'];
  if (orderType == 'DIGITAL') {
    return {
      isError: false,
      message: ""
    }
  }
  let isCreateAddress = (formData?.['create_shipping_checkbox'] || formData?.['add-new-address']) ? true : false;
  isCrateAddress = isCreateAddress || (formData['attributes[_shipping_address][shipping_address_id]'] ?? false);
  if (isCreateAddress) {
    let response = await createCustomerAddressWhenCheckout(dataUpsertAddress);
    if (response.status != 200 && response.status != 201) {
      return {
        isError: true,
        message: "配送先住所: この住所は既に登録されています。"
      }
    }
  } else {
    dataUpsertAddress['address_id'] = formData['attributes[_shipping_address][shipping_address_id]'] ?? "";
    let response = await editCustomerAddressWhenCheckout(dataUpsertAddress);
    if (response.status != 200 && response.status != 201) {
      return {
        isError: true,
        message: "配送先住所: 住所の更新中にエラーが発生しました。入力された情報に誤りがないかご確認ください。"
      }
    }
  }
  return {
    isError: false,
    message: ""
  }
}

async function editCustomerAddressWhenCheckout(dataCreateAddress) {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json;charset=utf-8"
    },
    body: JSON.stringify(dataCreateAddress),
  };
  const response = await fetch("/apps/dev-1/address/update", requestOptions)
  return await response.json()
}


async function createCustomerAddressWhenCheckout(dataCreateAddress) {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json;charset=utf-8"
    },
    body: JSON.stringify(dataCreateAddress),
  };
  const response = await fetch("/apps/dev-1/address/create", requestOptions)
  return await response.json()

}


async function removeAdditionalFeeItem() {
  const cartInfo = await getCartApi();
  const cartItems = cartInfo.items;
  if (typeof cartItems !== 'undefined') {
    const removeParam = {};
    for (let i = 0; i < cartItems.length; i++) {
      if (cartItems[i].handle == 'deposit' || cartItems[i].handle == 'balance') {
        removeParam[`${cartItems[i].key}`] = 0;
      }
    }
    if (Object.keys(removeParam).length > 0) {
      $.ajax({
        url: "/cart/update.js",
        method: 'POST',
        dataType: 'json',
        data: {
          updates: removeParam
        },
        success: function(response) {
        },
        error: function(response) {
        }
      });
    }
  }
}

const provinceList = [
  {
    "en": "Aichi",
    "jp": "愛知県"
  },
  {
    "en": "Akita",
    "jp": "秋田県"
  },
  {
    "en": "Aomori",
    "jp": "青森県"
  },
  {
    "en": "Chiba",
    "jp": "千葉県"
  },
  {
    "en": "Ehime",
    "jp": "愛媛県"
  },
  {
    "en": "Fukui",
    "jp": "福井県"
  },
  {
    "en": "Fukuoka",
    "jp": "福岡県"
  },
  {
    "en": "Fukushima",
    "jp": "福島県"
  },
  {
    "en": "Gifu",
    "jp": "岐阜県"
  },
  {
    "en": "Gunma",
    "jp": "群馬県"
  },
  {
    "en": "Hiroshima",
    "jp": "広島県"
  },
  {
    "en": "Hokkaidō",
    "jp": "北海道"
  },
  {
    "en": "Hyōgo",
    "jp": "兵庫県"
  },
  {
    "en": "Ibaraki",
    "jp": "茨城県"
  },
  {
    "en": "Ishikawa",
    "jp": "石川県"
  },
  {
    "en": "Iwate",
    "jp": "岩手県"
  },
  {
    "en": "Kagawa",
    "jp": "香川県"
  },
  {
    "en": "Yamanashi",
    "jp": "山梨県"
  },
  {
    "en": "Yamaguchi",
    "jp": "山口県"
  },
  {
    "en": "Kōchi",
    "jp": "高知県"
  },
  {
    "en": "Kumamoto",
    "jp": "熊本県"
  },
  {
    "en": "Kyōto",
    "jp": "京都府"
  },
  {
    "en": "Mie",
    "jp": "三重県"
  },
  {
    "en": "Yamagata",
    "jp": "山形県"
  },
  {
    "en": "Miyazaki",
    "jp": "宮崎県"
  },
  {
    "en": "Nagano",
    "jp": "長野県"
  },
  {
    "en": "Nagasaki",
    "jp": "長崎県"
  },
  {
    "en": "Nara",
    "jp": "奈良県"
  },
  {
    "en": "Niigata",
    "jp": "新潟県"
  },
  {
    "en": "Ōita",
    "jp": "大分県"
  },
  {
    "en": "Okayama",
    "jp": "岡山県"
  },
  {
    "en": "Okinawa",
    "jp": "沖縄県"
  },
  {
    "en": "Ōsaka",
    "jp": "大阪府"
  },
  {
    "en": "Saga",
    "jp": "佐賀県"
  },
  {
    "en": "Saitama",
    "jp": "埼玉県"
  },
  {
    "en": "Shiga",
    "jp": "滋賀県"
  },
  {
    "en": "Shimane",
    "jp": "島根県"
  },
  {
    "en": "Shizuoka",
    "jp": "静岡県"
  },
  {
    "en": "Tochigi",
    "jp": "栃木県"
  },
  {
    "en": "Tokushima",
    "jp": "徳島県"
  },
  {
    "en": "Tottori",
    "jp": "鳥取県"
  },
  {
    "en": "Toyama",
    "jp": "富山県"
  },
  {
    "en": "Tōkyō",
    "jp": "東京都"
  },
  {
    "en": "Miyagi",
    "jp": "宮城県"
  },
  {
    "en": "Wakayama",
    "jp": "和歌山県"
  },
  {
    "en": "Kanagawa",
    "jp": "神奈川県"
  },
  {
    "en": "Kagoshima",
    "jp": "鹿児島県"
  }
]

const provinceShopify = {
  "JP-01": {
    "label": "北海道",
    "alternate_names": ["Hokkaido", "Hokkaido Prefecture", "北海道"],
    "code": "JP-01",
    "value": "Hokkaidō"
  },
  "JP-02": {
    "label": "青森県",
    "alternate_names": ["Aomori Prefecture", "Aomori-ken", "青森県", "青森"],
    "code": "JP-02",
    "value": "Aomori"
  },
  "JP-03": {
    "label": "岩手県",
    "alternate_names": ["Iwate Prefecture", "Iwate-ken", "岩手県", "岩手"],
    "code": "JP-03",
    "value": "Iwate"
  },
  "JP-04": {
    "label": "宮城県",
    "alternate_names": ["Miyagi Prefecture", "Miyagi-ken", "宮城県", "宮城"],
    "code": "JP-04",
    "value": "Miyagi"
  },
  "JP-05": {
    "label": "秋田県",
    "alternate_names": ["Akita Prefecture", "Akita-ken", "秋田県", "秋田"],
    "code": "JP-05",
    "value": "Akita"
  },
  "JP-06": {
    "label": "山形県",
    "alternate_names": ["Yamagata Prefecture", "Yamagata-ken", "山形県", "山形"],
    "code": "JP-06",
    "value": "Yamagata"
  },
  "JP-07": {
    "label": "福島県",
    "alternate_names": ["Fukushima Prefecture", "Fukushima-ken", "福島県", "福島"],
    "code": "JP-07",
    "value": "Fukushima"
  },
  "JP-08": {
    "label": "茨城県",
    "alternate_names": ["Ibaraki Prefecture", "Ibaraki-ken", "茨城県", "茨城"],
    "code": "JP-08",
    "value": "Ibaraki"
  },
  "JP-09": {
    "label": "栃木県",
    "alternate_names": ["Tochigi Prefecture", "Tochigi-ken", "栃木県", "栃木"],
    "code": "JP-09",
    "value": "Tochigi"
  },
  "JP-10": {
    "label": "群馬県",
    "alternate_names": ["Gunma Prefecture", "Gunma-ken", "群馬県", "群馬"],
    "code": "JP-10",
    "value": "Gunma"
  },
  "JP-11": {
    "label": "埼玉県",
    "alternate_names": ["Saitama Prefecture", "Saitama-ken", "埼玉県", "埼玉"],
    "code": "JP-11",
    "value": "Saitama"
  },
  "JP-12": {
    "label": "千葉県",
    "alternate_names": ["Chiba Prefecture", "Chiba-ken", "千葉県", "千葉"],
    "code": "JP-12",
    "value": "Chiba"
  },
  "JP-13": {
    "label": "東京都",
    "alternate_names": ["Tokyo", "Tokyo Prefecture", "Tōkyō-to", "Tokyo-to", "東京都", "東京"],
    "code": "JP-13",
    "value": "Tōkyō"
  },
  "JP-14": {
    "label": "神奈川県",
    "alternate_names": ["Kanagawa Prefecture", "Kanagawa-ken", "神奈川県", "神奈川"],
    "code": "JP-14",
    "value": "Kanagawa"
  },
  "JP-15": {
    "label": "新潟県",
    "alternate_names": ["Niigata Prefecture", "Niigata-ken", "新潟県", "新潟"],
    "code": "JP-15",
    "value": "Niigata"
  },
  "JP-16": {
    "label": "富山県",
    "alternate_names": ["Toyama Prefecture", "Toyama-ken", "富山県", "富山"],
    "code": "JP-16",
    "value": "Toyama"
  },
  "JP-17": {
    "label": "石川県",
    "alternate_names": ["Ishikawa Prefecture", "Ishikawa-ken", "石川県", "石川"],
    "code": "JP-17",
    "value": "Ishikawa"
  },
  "JP-18": {
    "label": "福井県",
    "alternate_names": ["Fukui Prefecture", "Fukui-ken", "福井県", "福井"],
    "code": "JP-18",
    "value": "Fukui"
  },
  "JP-19": {
    "label": "山梨県",
    "alternate_names": ["Yamanashi Prefecture", "Yamanashi-ken", "山梨県", "山梨"],
    "code": "JP-19",
    "value": "Yamanashi"
  },
  "JP-20": {
    "label": "長野県",
    "alternate_names": ["Nagano Prefecture", "Nagano-ken", "長野県", "長野"],
    "code": "JP-20",
    "value": "Nagano"
  },
  "JP-21": {
    "label": "岐阜県",
    "alternate_names": ["Gifu Prefecture", "Gifu-ken", "岐阜県", "岐阜"],
    "code": "JP-21",
    "value": "Gifu"
  },
  "JP-22": {
    "label": "静岡県",
    "alternate_names": ["Shizuoka Prefecture", "Shizuoka-ken", "静岡県", "静岡"],
    "code": "JP-22",
    "value": "Shizuoka"
  },
  "JP-23": {
    "label": "愛知県",
    "alternate_names": ["Aichi Prefecture", "Aichi-ken", "愛知県", "愛知"],
    "code": "JP-23",
    "value": "Aichi"
  },
  "JP-24": {
    "label": "三重県",
    "alternate_names": ["Mie Prefecture", "Mie-ken", "三重県", "三重"],
    "code": "JP-24",
    "value": "Mie"
  },
  "JP-25": {
    "label": "滋賀県",
    "alternate_names": ["Shiga Prefecture", "Shiga-ken", "滋賀県", "滋賀"],
    "code": "JP-25",
    "value": "Shiga"
  },
  "JP-26": {
    "label": "京都府",
    "alternate_names": ["Kyoto", "Kyoto Prefecture", "Kyōto-fu", "Kyoto-fu", "京都府", "京都"],
    "code": "JP-26",
    "value": "Kyōto"
  },
  "JP-27": {
    "label": "大阪府",
    "alternate_names": ["Osaka", "Osaka Prefecture", "Ōsaka-fu", "Osaka-fu", "大阪府", "大阪"],
    "code": "JP-27",
    "value": "Ōsaka"
  },
  "JP-28": {
    "label": "兵庫県",
    "alternate_names": ["Hyogo", "Hyogo Prefecture", "Hyōgo-ken", "Hyogo-ken", "兵庫県", "兵庫"],
    "code": "JP-28",
    "value": "Hyōgo"
  },
  "JP-29": {
    "label": "奈良県",
    "alternate_names": ["Nara Prefecture", "Nara-ken", "奈良県", "奈良"],
    "code": "JP-29",
    "value": "Nara"
  },
  "JP-30": {
    "label": "和歌山県",
    "alternate_names": ["Wakayama Prefecture", "Wakayama-ken", "和歌山県", "和歌山"],
    "code": "JP-30",
    "value": "Wakayama"
  },
  "JP-31": {
    "label": "鳥取県",
    "alternate_names": ["Tottori Prefecture", "Tottori-ken", "鳥取県", "鳥取"],
    "code": "JP-31",
    "value": "Tottori"
  },
  "JP-32": {
    "label": "島根県",
    "alternate_names": ["Shimane Prefecture", "Shimane-ken", "島根県", "島根"],
    "code": "JP-32",
    "value": "Shimane"
  },
  "JP-33": {
    "label": "岡山県",
    "alternate_names": ["Okayama Prefecture", "Okayama-ken", "岡山県", "岡山"],
    "code": "JP-33",
    "value": "Okayama"
  },
  "JP-34": {
    "label": "広島県",
    "alternate_names": ["Hiroshima Prefecture", "Hiroshima-ken", "広島県", "広島"],
    "code": "JP-34",
    "value": "Hiroshima"
  },
  "JP-35": {
    "label": "山口県",
    "alternate_names": ["Yamaguchi Prefecture", "Yamaguchi-ken", "山口県", "山口"],
    "code": "JP-35",
    "value": "Yamaguchi"
  },
  "JP-36": {
    "label": "徳島県",
    "alternate_names": ["Tokushima Prefecture", "Tokushima-ken", "徳島県", "徳島"],
    "code": "JP-36",
    "value": "Tokushima"
  },
  "JP-37": {
    "label": "香川県",
    "alternate_names": ["Kagawa Prefecture", "Kagawa-ken", "香川県", "香川"],
    "code": "JP-37",
    "value": "Kagawa"
  },
  "JP-38": {
    "label": "愛媛県",
    "alternate_names": ["Ehime Prefecture", "Ehime-ken", "愛媛県", "愛媛"],
    "code": "JP-38",
    "value": "Ehime"
  },
  "JP-39": {
    "label": "高知県",
    "alternate_names": ["Kochi", "Kochi Prefecture", "Kōchi-ken", "Kochi-ken", "高知県", "高知"],
    "code": "JP-39",
    "value": "Kōchi"
  },
  "JP-40": {
    "label": "福岡県",
    "alternate_names": ["Fukuoka Prefecture", "Fukuoka-ken", "福岡県", "福岡"],
    "code": "JP-40",
    "value": "Fukuoka"
  },
  "JP-41": {
    "label": "佐賀県",
    "alternate_names": ["Saga Prefecture", "Saga-ken", "佐賀県", "佐賀"],
    "code": "JP-41",
    "value": "Saga"
  },
  "JP-42": {
    "label": "長崎県",
    "alternate_names": ["Nagasaki Prefecture", "Nagasaki-ken", "長崎県", "長崎"],
    "code": "JP-42",
    "value": "Nagasaki"
  },
  "JP-43": {
    "label": "熊本県",
    "alternate_names": ["Kumamoto Prefecture", "Kumamoto-ken", "熊本県", "熊本"],
    "code": "JP-43",
    "value": "Kumamoto"
  },
  "JP-44": {
    "label": "大分県",
    "alternate_names": ["Oita", "Oita Prefecture", "Ōita-ken", "Oita-ken", "大分県", "大分"],
    "code": "JP-44",
    "value": "Ōita"
  },
  "JP-45": {
    "label": "宮崎県",
    "alternate_names": ["Miyazaki Prefecture", "Miyazaki-ken", "宮崎県", "宮崎"],
    "code": "JP-45",
    "value": "Miyazaki"
  },
  "JP-46": {
    "label": "鹿児島県",
    "alternate_names": ["Kagoshima Prefecture", "Kagoshima-ken", "鹿児島県", "鹿児島"],
    "code": "JP-46",
    "value": "Kagoshima"
  },
  "JP-47": {
    "label": "沖縄県",
    "alternate_names": ["Okinawa Prefecture", "Okinawa-ken", "沖縄県", "沖縄"],
    "code": "JP-47",
    "value": "Okinawa"
  }
}

async function getDepositItem(totalOfPrice) {
  try {
    const depositItem = await fetch('/products/deposit.js', {});
    if (depositItem) {
      const product = await depositItem.json();
      return {
        "id": product.variants[0].id,
        "quantity": 1,
        "properties": {
          "_type": "BULK",
          "_item_type": 'deposit',
          "_price_company": Math.round(totalOfPrice * 0.2),
          "_has_custom_price": true
        }
      };
    }
    return false;
  } catch (error) {
    console.error('Error 2:', error);
    e.preventDefault();
    return false;
  }
}

async function getBalanceItem(orderType, balancePrice) {
  try {
    const balaceItem = await fetch('/products/balance.js', {});
    if (balaceItem) {
      const product = await balaceItem.json();
      return {
        "id": product.variants[0].id,
        "quantity": 1,
        "properties": {
          "_type": orderType,
          "_item_type": 'balance',
          "_price_company": balancePrice,
          "_has_custom_price": true
        }
      };
    }
    return false;
  } catch (error) {
    console.error('Error 2:', error);
    e.preventDefault();
    return false;
  }
}

async function updateAttributesAndReOrderLineItem(orderType, additionalItem = null, additionalItemBalance = null) {
  let limitNumMeterForDiscountCut = 0.9;
  const cartItems = await getCartItems();
  if (isCheckout) {
    cartItems.reverse();
  }
  let itemAddCarts = {};
  itemAddCarts['items'] = [];
  let itemsRemove = {};

  if ((orderType === 'DIGITAL' || orderType === 'CATALOG') && Array.isArray(cartItems)) {
    cartItems.forEach((cartItem) => {
      itemAddCarts['items'].push({
        id: cartItem?.id,
        quantity: cartItem?.quantity,
        properties: cartItem?.properties
      })
      itemsRemove = {
        ...itemsRemove,
        [cartItem?.key]: 0
      }
    });
  }

  if (orderType === 'BULK') {
    if (additionalItem) {
      itemAddCarts['items'].push(additionalItem);
    }
    if (additionalItemBalance) {
      itemAddCarts['items'].push(additionalItemBalance);
    }
    for (let i = 0; i < cartItems.length; i++) {
      itemsRemove = {
        ...itemsRemove,
        [cartItems[i].key]: 0
      }
      itemAddCarts['items'].push({
        id: cartItems[i].id,
        quantity: cartItems[i].quantity,
        properties: {
          ...(cartItems[i]?.properties || {}),
          '_price_in_company_prd_discount_table' : cartItems[i]?.properties?._original_price_company,
          '_先方品番': document.querySelector(`input[name="attributes[貴社品番-${cartItems[i].id}]"]`)?.value || ''
        },
      })
    }
  }

  if (orderType === 'CUT' || orderType === 'PRINT') {
    if (additionalItem) {
      itemAddCarts['items'].push(additionalItem);
    }
    if (additionalItemBalance) {
      itemAddCarts['items'].push(additionalItemBalance);
    }
    let itemsFabric = [],
        itemsCutFee = {},
        itemsPrintFee = {},
        itemsDesignFee = {};

    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];
      itemsRemove = {
        ...itemsRemove,
        [cartItems[i].key]: 0
      }
      if (item.sku.includes('_zuan_')) {
        if (typeof itemsDesignFee[item.properties['_variant_id_fabric']] == 'undefined') {
          itemsDesignFee[item.properties['_variant_id_fabric']] = {};
        }
        itemsDesignFee = {
          ...itemsDesignFee,
          [item.properties['_variant_id_fabric']]: {
            ...itemsDesignFee[item.properties['_variant_id_fabric']],
            [item.id]: item
          }
        }
      } else if (item.sku.includes('printfee_')) {
        if (typeof itemsPrintFee[item.properties['_variant_id_fabric']] == 'undefined') {
          itemsPrintFee[item.properties['_variant_id_fabric']] = {};
        }
        itemsPrintFee = {
          ...itemsPrintFee,
          [item.properties['_variant_id_fabric']]: {
            ...itemsPrintFee[item.properties['_variant_id_fabric']],
            [item.properties['_design_variant_id']]: item
          }
        }
      } else if (item.sku.includes('cutfee_')) {
        if (orderType == 'CUT') {
          itemsCutFee = {
            ...itemsCutFee,
            [item.properties['_variant_id_fabric']]: item
          }
        } else { // PRINT
          if (typeof itemsCutFee[item.properties['_variant_id_fabric']] == 'undefined') {
            itemsCutFee[item.properties['_variant_id_fabric']] = {};
          }
          itemsCutFee = {
            ...itemsCutFee,
            [item.properties['_variant_id_fabric']]: {
              ...itemsCutFee[item.properties['_variant_id_fabric']],
              [item.properties['_design_variant_id']]: item
            }
          }
        }
      } else {
        itemsFabric.push(item);
      }
    }
    for (let i = 0; i < itemsFabric.length; i++) {
      const variantFabricId = itemsFabric[i].id;
      const designItemId = itemsFabric[i].properties?._design_variant_id;
      // add print item
      if (typeof itemsPrintFee[variantFabricId] != 'undefined' && typeof itemsPrintFee[variantFabricId][designItemId] != 'undefined') {
        itemAddCarts['items'].push({
          id: itemsPrintFee[variantFabricId][designItemId].id,
          quantity: itemsPrintFee[variantFabricId][designItemId].quantity,
          properties: itemsPrintFee[variantFabricId][designItemId]?.properties || {},
        });
      }
      
      // add cut item
      if (orderType == 'CUT') {
        if (typeof itemsCutFee[variantFabricId] != 'undefined') {
          itemAddCarts['items'].push({
            id: itemsCutFee[variantFabricId].id,
            quantity: itemsCutFee[variantFabricId].quantity,
            properties: itemsCutFee[variantFabricId]?.properties || {},
          });
        }
      } else {
        if (typeof itemsCutFee[variantFabricId] != 'undefined' && typeof itemsCutFee[variantFabricId][designItemId] != 'undefined') {
          itemAddCarts['items'].push({
            id: itemsCutFee[variantFabricId][designItemId].id,
            quantity: itemsCutFee[variantFabricId][designItemId].quantity,
            properties: itemsCutFee[variantFabricId][designItemId]?.properties || {},
          });
        }
      }
      
      // add design item
      if (typeof itemsDesignFee[variantFabricId] != 'undefined' && typeof itemsDesignFee[variantFabricId][designItemId] != 'undefined') {
        itemAddCarts['items'].push({
          id: itemsDesignFee[variantFabricId][designItemId].id,
          quantity: itemsDesignFee[variantFabricId][designItemId].quantity,
          properties: itemsDesignFee[variantFabricId][designItemId]?.properties || {},
        });
      }

      if (orderType == 'CUT' && isSpecialCompanyForDiscountCutOrder && (itemsFabric[i].quantity / 10) > limitNumMeterForDiscountCut){
        itemsFabric[i].properties._price_company = Math.floor(itemsFabric[i]?.properties._price_by_m/10);
        itemsFabric[i].properties._original_price_company = itemsFabric[i]?.properties._price_by_m;
      } else if (orderType == 'CUT' && isSpecialCompanyForDiscountCutOrder && (itemsFabric[i].quantity / 10) <= limitNumMeterForDiscountCut){
        itemsFabric[i].properties._price_company = 0;
        itemsFabric[i].properties._original_price_company = 0;
      }
      // add fabrics
      itemAddCarts['items'].push({
        id: itemsFabric[i].id,
        quantity: itemsFabric[i].quantity,
        properties: {
          ...(itemsFabric[i]?.properties || {}),
          '_price_in_company_prd_discount_table' : itemsFabric[i]?.properties?._original_price_company,
          '_先方品番': document.querySelector(`input[name="attributes[貴社品番-${itemsFabric[i].id}]"]`)?.value || ''
        },
      })
    }
  }
  await updateAttributeCartAndRemoveItem(itemsRemove, itemAddCarts, orderType);
  localStorage.removeItem('receipt_items');
  cancelFilterLoading();
  window.location.href = '/checkout';
}

async function getCartItems() {
  let res = await fetch('/cart.js', {});
  const resBody = await res.json();
  return resBody.items;
}

async function updateAttributeCartAndRemoveItem(itemsRemove = {}, itemsAdd = null, orderType = 'CUT') {
  const allCartAttributes = $('#cart').serializeArray();
  const lastNameCustomer = customerInfoLogin.last_name|| "";
  const firstNameCustomer = customerInfoLogin.first_name || "";
  const companyUserLogin = customerInfoLogin.company || "";
  const companyCodeCustomerLogin = window.localStorage.getItem('current_company') || "";
  const companyNameCustomerLogin = window.localStorage.getItem('current_company_name') || "";

  const freeOrderCheckbox = allCartAttributes.find(attr => attr.name === 'free-order-checkbox');
  let valueOrderCheckbox = null;
  if (freeOrderCheckbox && freeOrderCheckbox.value == 'on') {
    valueOrderCheckbox = 1;
  }
  let attributes = {};
  for (let i = 0; i < allCartAttributes.length; i++) {
    const attributeItem = allCartAttributes[i];
    const attributesItemName = attributeItem.name;
    if (attributesItemName.startsWith('attributes[') && attributeItem.value) {
      const attributesItemNameArray = attributesItemName.match(/\[([^]]+)]|([^\[\]]+)/g);
      if (attributesItemNameArray.length === 2) {
        attributes = {
          ...attributes,
          [attributesItemNameArray[1]]: attributeItem.value
        };
      } else if (attributesItemNameArray.length === 3) {
        if (typeof attributes[attributesItemNameArray[1]] == 'undefined') {
          attributes = {
            ...attributes,
            [attributesItemNameArray[1]]: {}
          };
        }
        attributes = {
          ...attributes,
          [attributesItemNameArray[1]]: {
            ...attributes[attributesItemNameArray[1]],
            [attributesItemNameArray[2]]: attributeItem.value
          }
        };
      }
    }
  }
  if (orderType === 'BULK') {
    attributes.希望着日 = getNextWorkingDay(getJapanTime());
  }
  attributes._customer_info = {
    last_name: lastNameCustomer,
    first_name: firstNameCustomer,
    company_code: companyCodeCustomerLogin,
    company_name: companyNameCustomerLogin,
    company_user_login: companyUserLogin
  };

  attributes = {
    ...attributes,
    "is_checkout": true,
    "is_order_free": valueOrderCheckbox
  };

  const bodyUpdateCart = {
    updates: itemsRemove,
    attributes
  }
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(bodyUpdateCart)
  });

  if (itemsAdd) {
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(itemsAdd)
    });
  }
}

const getValueHasKeyInAttribute = (key, attributes) => {
  return attributes.find((attr) => attr.name === key)?.value || null;
}

function resetAttributeCartState(resetAttributes = {}) {
  for (const attrKey in resetAttributes) {
    resetAttributes[attrKey] = "";
  }

  return resetAttributes;
}

async function updateCartApi(attributes, changedItems = {}) {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };
  const updateCartUrl = "/cart/update.js";
  const bodyPayload =  {
    attributes: attributes,
    updates: changedItems
  }

  try {
    await fetch(updateCartUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(bodyPayload)
    })
  } catch(error) {
    throw error?.message
  }
}

async function getCartApi() {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };
  const updateCartUrl = "/cart.js";

  try {
    const res = await fetch(updateCartUrl, {
      method: "GET",
      headers: headers,
    })
    return res.json();
  } catch(error) {
    throw error?.message
  }
}

async function resetAttributeCart() {
  try {
    const cart = await getCartApi();
    if (!cart || !cart.items || cart?.items.length > 0 || Object.keys(cart.attributes).length === 0 ) return;
    const resetedAttribute = resetAttributeCartState(cart.attributes);
    await updateCartApi(resetedAttribute);
  } catch (error) {
    console.error("Reset attribute fail", error)
  }
}

function checkHolidays(date) {
  let holidays = getListHolidays.split(',');
  for (var i = 0; i < holidays.length; i++) {
    let holiday = holidays[i].replaceAll("/", "-");
    if (holiday == date) {
      return true;
    }
  }
  return false;
}

function checkWeekend(date) {
  let day = date.getDay();
  return (day == 0 || day == 6) ? true : false;
}

function formatDateString(date) {
  let yyyy = date.getFullYear();
  let mm = String(date.getMonth() + 1).padStart(2, '0');
  let dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function getNextWorkingDay(nowDate) {
  let [datePart, timePart] = nowDate.split("T");
  let [year, month, day] = datePart.split("-").map(Number);
  let [hour, minute] = timePart.split(":").map(Number);
  const DATE_DELIVERY = 13;
  const MINUTES_DELIVERY = 30;

  let nextDate = new Date(year, month - 1, day);

  if (hour > DATE_DELIVERY || (hour === DATE_DELIVERY && minute >= MINUTES_DELIVERY)) {
    nextDate.setDate(nextDate.getDate() + 2);
  } else {
    nextDate.setDate(nextDate.getDate() + 1);
  }

  while (checkWeekend(nextDate) || checkHolidays(formatDateString(nextDate))) {
    nextDate.setDate(nextDate.getDate() + 1);
  }

  return formatDateString(nextDate);
}

function getJapanTime(date = null) {
  if (!date) {
    date = new Date();
  }
  let formatter = new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
  let parts = formatter.formatToParts(date);
  let dateParts = {};
  parts.forEach((part) => {
    dateParts[part.type] = part.value;
  });

  return `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}+09:00`;
}

function isInHiddenTimePeriod() {
  let now = new Date();
  let jstNow = getJapanTime(now);

  let start = new Date("2025-04-28T13:30:00+09:00");
  let end = new Date("2025-05-06T23:59:59+09:00");

  start = getJapanTime(start);
  end = getJapanTime(end);

  return jstNow >= start && jstNow <= end;
}
